import { Box, styled } from "@mui/material";

export const SectionsArrowBox = styled(Box)(() => ({
  minWidth: 25,
  minHeight: 25,
}));
